export type PolicyMode = "notify-only" | "auto-critical" | "auto-all";
export interface UpdatePolicy { schemaVersion: 1; mode: PolicyMode; updatedAt: string; updatedBy: string }
export const DEFAULT_POLICY_MODE: PolicyMode = "auto-critical";
export const UPDATE_POLICY_PK = "system";
export const UPDATE_POLICY_RK = "update-policy";

const MODES: PolicyMode[] = ["notify-only", "auto-critical", "auto-all"];
export function isPolicyMode(x: unknown): x is PolicyMode { return typeof x === "string" && MODES.includes(x as PolicyMode); }

export function defaultPolicy(nowIso: string): UpdatePolicy {
  return { schemaVersion: 1, mode: DEFAULT_POLICY_MODE, updatedAt: nowIso, updatedBy: "default" };
}
export function updatePolicyToEntity(p: UpdatePolicy): { partitionKey: string; rowKey: string; value: string } {
  return { partitionKey: UPDATE_POLICY_PK, rowKey: UPDATE_POLICY_RK, value: JSON.stringify(p) };
}
export function entityToUpdatePolicy(e: { value: string }): UpdatePolicy { return JSON.parse(e.value) as UpdatePolicy; }
